import { render, staticRenderFns } from "./FragebogenModule.vue?vue&type=template&id=35a55f7e&scoped=true&"
import script from "./FragebogenModule.vue?vue&type=script&lang=js&"
export * from "./FragebogenModule.vue?vue&type=script&lang=js&"
import style0 from "./FragebogenModule.vue?vue&type=style&index=0&id=35a55f7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a55f7e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VBtn,VCheckbox,VCol,VIcon,VRow,VTab,VTabItem,VTabs})
